export default function EmptyDrawHistoryIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* document stack */}
      <rect
        x="10"
        y="16"
        width="36"
        height="44"
        rx="3"
        fill="currentColor"
        opacity="0.08"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <rect
        x="15"
        y="11"
        width="36"
        height="44"
        rx="3"
        fill="currentColor"
        opacity="0.05"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* lines on front doc */}
      <line
        x1="18"
        y1="26"
        x2="38"
        y2="26"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <line
        x1="18"
        y1="32"
        x2="38"
        y2="32"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <line
        x1="18"
        y1="38"
        x2="30"
        y2="38"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* empty circle with X */}
      <circle
        cx="46"
        cy="46"
        r="12"
        fill="var(--bg2, #fff)"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <line
        x1="41"
        y1="41"
        x2="51"
        y2="51"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <line
        x1="51"
        y1="41"
        x2="41"
        y2="51"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
